import { Components, Theme } from '@mui/material/styles';

const MuiSelect: Components<Theme>['MuiSelect'] = {
  styleOverrides: {
    select: {
      '&:focus': {
        backgroundColor: 'transparent',
      },
    },
  },
};

export default MuiSelect;
